<template>

  <div>
    <Modal
      :title="$t('titles.delete_parcs')"
      :submit="submit"
      :submit-label="$t('actions.delete')"
      :submitting="submitting"
    >

      <p>{{ $t('alerts.confirm_delete_parcs') }}</p>

    </Modal>
  </div>  

</template>

<script setup lang="ts">

import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import Modal from '../../../Modal.vue'
// @ts-ignore
import { closeDialog } from 'vue3-promise-dialog'
import Parcs from '../../../../models/Parcs'
import NotificationService from '../../../../services/NotificationService'

interface Props {
  parcs: Parcs
}

const props = defineProps<Props>()

const { t } = useI18n()

const submitting = ref<boolean>(false)

async function submit() {

  submitting.value = true

  Parcs.destroy(props.parcs.ID)
    .then(() => {
      NotificationService.success(t('alerts.parcs_deleted'))
      closeDialog(null)
    })
    .catch((error) => {
      console.error(error)
      const msg = t('alerts.couldnt_delete_parcs')
      NotificationService.error(msg)
    })
    .finally(() => {
      submitting.value = false
    })

}

</script>
